import { defineMessages, type MessageDescriptor } from 'react-intl';

const messages: Record<'title' | 'body' | 'keepEditing' | 'publish', MessageDescriptor> =
	defineMessages({
		title: {
			id: 'company-hub-common.publish-migration-modal.title',
			defaultMessage: 'Replace current help center?',
			description: 'Title of the confirmation dialog before publishing a migrated help center.',
		},
		body: {
			id: 'company-hub-common.publish-migration-modal.body',
			defaultMessage:
				'Publishing will permanently replace your existing help center with the new version. This action is final and cannot be undone.',
			description:
				'Warning that publishing a migrated help center permanently replaces the existing one.',
		},
		keepEditing: {
			id: 'company-hub-common.publish-migration-modal.keep-editing',
			defaultMessage: 'Keep editing',
			description: 'Dismiss the confirmation dialog without publishing the migrated help center.',
		},
		publish: {
			id: 'company-hub-common.publish-migration-modal.publish',
			defaultMessage: 'Publish',
			description: 'Confirm publishing the migrated help center and replacing the existing one.',
		},
	});

export default messages;
